var cov_2anfhalpgg = function () {
  var path = '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/directives/selectedTable.js',
      hash = 'acba6e6dd868103f3cb155ac2333ec57eb634c03',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/directives/selectedTable.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 75,
          column: 3
        }
      },
      '1': {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 74,
          column: 4
        }
      },
      '2': {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 50,
          column: 46
        }
      },
      '3': {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 55,
          column: 9
        }
      },
      '4': {
        start: {
          line: 52,
          column: 8
        },
        end: {
          line: 54,
          column: 9
        }
      },
      '5': {
        start: {
          line: 53,
          column: 10
        },
        end: {
          line: 53,
          column: 87
        }
      },
      '6': {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 56,
          column: 33
        }
      },
      '7': {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 57,
          column: 39
        }
      },
      '8': {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 72,
          column: 9
        }
      },
      '9': {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 61,
          column: 9
        }
      },
      '10': {
        start: {
          line: 60,
          column: 10
        },
        end: {
          line: 60,
          column: 63
        }
      },
      '11': {
        start: {
          line: 62,
          column: 8
        },
        end: {
          line: 71,
          column: 9
        }
      },
      '12': {
        start: {
          line: 63,
          column: 10
        },
        end: {
          line: 68,
          column: 13
        }
      },
      '13': {
        start: {
          line: 64,
          column: 12
        },
        end: {
          line: 66,
          column: 13
        }
      },
      '14': {
        start: {
          line: 65,
          column: 14
        },
        end: {
          line: 65,
          column: 26
        }
      },
      '15': {
        start: {
          line: 67,
          column: 12
        },
        end: {
          line: 67,
          column: 123
        }
      },
      '16': {
        start: {
          line: 70,
          column: 10
        },
        end: {
          line: 70,
          column: 63
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 49
          },
          end: {
            line: 1,
            column: 50
          }
        },
        loc: {
          start: {
            line: 1,
            column: 61
          },
          end: {
            line: 75,
            column: 1
          }
        },
        line: 1
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 51,
            column: 29
          },
          end: {
            line: 51,
            column: 30
          }
        },
        loc: {
          start: {
            line: 51,
            column: 35
          },
          end: {
            line: 55,
            column: 7
          }
        },
        line: 51
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 58,
            column: 33
          },
          end: {
            line: 58,
            column: 34
          }
        },
        loc: {
          start: {
            line: 58,
            column: 39
          },
          end: {
            line: 72,
            column: 7
          }
        },
        line: 58
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 63,
            column: 41
          },
          end: {
            line: 63,
            column: 42
          }
        },
        loc: {
          start: {
            line: 63,
            column: 50
          },
          end: {
            line: 68,
            column: 11
          }
        },
        line: 63
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 53,
            column: 41
          },
          end: {
            line: 53,
            column: 86
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 53,
            column: 41
          },
          end: {
            line: 53,
            column: 56
          }
        }, {
          start: {
            line: 53,
            column: 60
          },
          end: {
            line: 53,
            column: 86
          }
        }],
        line: 53
      },
      '1': {
        loc: {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        }, {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        }],
        line: 59
      },
      '2': {
        loc: {
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 71,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 71,
            column: 9
          }
        }, {
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 71,
            column: 9
          }
        }],
        line: 62
      },
      '3': {
        loc: {
          start: {
            line: 64,
            column: 12
          },
          end: {
            line: 66,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 64,
            column: 12
          },
          end: {
            line: 66,
            column: 13
          }
        }, {
          start: {
            line: 64,
            column: 12
          },
          end: {
            line: 66,
            column: 13
          }
        }],
        line: 64
      },
      '4': {
        loc: {
          start: {
            line: 64,
            column: 16
          },
          end: {
            line: 64,
            column: 102
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 64,
            column: 17
          },
          end: {
            line: 64,
            column: 53
          }
        }, {
          start: {
            line: 64,
            column: 59
          },
          end: {
            line: 64,
            column: 101
          }
        }],
        line: 64
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_2anfhalpgg.s[0]++;
angular.module('app').directive('selectedTable', function ($timeout) {
  cov_2anfhalpgg.f[0]++;
  cov_2anfhalpgg.s[1]++;

  return {
    restrict: 'A',
    template: '<div style="height: 100%; width: 100%" class="delta-table-select">\n       <div class="delta-table-select-header">\n        <div class="delta-table-select-image" ng-if="withImage"></div>\n        <div class="delta-table-select-label">\n          <div style="align-items: center;background: transparent;" class="display-flex header_formularNew">\n            <h3 style="min-width: 160px;">{{text}}</h3>\n            <div class="m-r m-l" style="flex: 1; min-width: 100px;">\n              <div class="input-group full-width formular_seacrhBar">\n                  <span class="input-group-addon">\n                    <i class="fa fa-search"></i>\n                  </span>\n                  <input ng-change="filterTableProjet()" type="text" placeholder="{{\'PROJECT.SEARCH_PROJECT\'|translate}}" class="form-control" ng-model="searchTableText">\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="delta-table-select-checked">\n          <div class="checkbox checkbox-success" >\n            <input id="{{createAt}}"  type="checkbox" ng-model="selectAll" ng-change="selectAllItem()">\n            <label for="{{createAt}}">_</label>\n          </div>\n        </div>\n       </div>\n        <div class="delta-table-select-body theme-scrollbar" >\n            <div class="delta-table-select-line" ng-repeat="item in data" >\n                <div class="delta-table-select-image" ng-if="withImage">\n                    <img ng-if="item.isImg"  src="{{item.img}}">\n                </div>\n                <div class="delta-table-select-label" ng-click="selectedItems[item.id] = !selectedItems[item.id]">{{item.CODE_PRJ}}: {{item.LIBELLE_PROJET}}</div>\n                <div class="delta-table-select-checked">\n                  <div class="checkbox checkbox-success" >\n                    <input id="{{createAt + \'_\' + item.id}}" type="checkbox" ng-disabled="lockedItems[item.id]" ng-change="selectAll = false" ng-model="selectedItems[item.id]">\n                    <label for="{{createAt + \'_\' + item.id}}" >_</label>\n                  </div>\n                </div>\n            </div>\n        </div>\n     </div>',
    scope: {
      lockedItems: '=',
      selectedItems: '=',
      text: '@',
      data: '=',
      withImage: '=?'
    },
    link: function link(scope) {
      cov_2anfhalpgg.s[2]++;

      scope.createAt = new Date().getTime();
      cov_2anfhalpgg.s[3]++;
      scope.selectAllItem = function () {
        cov_2anfhalpgg.f[1]++;
        cov_2anfhalpgg.s[4]++;

        for (var _iterator = scope.data, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
          }

          var item = _ref;
          cov_2anfhalpgg.s[5]++;

          scope.selectedItems[item.id] = (cov_2anfhalpgg.b[0][0]++, scope.selectAll) || (cov_2anfhalpgg.b[0][1]++, scope.lockedItems[item.id]);
        }
      };
      cov_2anfhalpgg.s[6]++;
      scope.searchTableText = '';
      cov_2anfhalpgg.s[7]++;
      scope.clone_listTableData = null;
      cov_2anfhalpgg.s[8]++;
      scope.filterTableProjet = function () {
        cov_2anfhalpgg.f[2]++;
        cov_2anfhalpgg.s[9]++;

        if (scope.clone_listTableData == null) {
          cov_2anfhalpgg.b[1][0]++;
          cov_2anfhalpgg.s[10]++;

          scope.clone_listTableData = angular.copy(scope.data);
        } else {
          cov_2anfhalpgg.b[1][1]++;
        }
        cov_2anfhalpgg.s[11]++;
        if (scope.searchTableText != '') {
          cov_2anfhalpgg.b[2][0]++;
          cov_2anfhalpgg.s[12]++;

          scope.data = scope.data.filter(function (value) {
            cov_2anfhalpgg.f[3]++;
            cov_2anfhalpgg.s[13]++;

            if ((cov_2anfhalpgg.b[4][0]++, typeof value.CODE_PRJ == 'undefined') || (cov_2anfhalpgg.b[4][1]++, typeof value.LIBELLE_PROJET == 'undefined')) {
              cov_2anfhalpgg.b[3][0]++;
              cov_2anfhalpgg.s[14]++;

              return true;
            } else {
              cov_2anfhalpgg.b[3][1]++;
            }
            cov_2anfhalpgg.s[15]++;
            return (value.CODE_PRJ + ' ' + value.LIBELLE_PROJET).toLowerCase().includes(scope.searchTableText.toLowerCase());
          });
        } else {
          cov_2anfhalpgg.b[2][1]++;
          cov_2anfhalpgg.s[16]++;

          scope.data = angular.copy(scope.clone_listTableData);
        }
      };
    }
  };
});